const productOptionContainers = document.querySelectorAll('.product-option-select--container');
const productOptionValues = document.querySelectorAll('.product-option--value');
const productJson = document.querySelector('[data-product-json]');
const productIdInput = document.querySelector('input[name=id]')

let closeAllProductOptionContainers = () => {
    productOptionContainers.forEach((el) => {
        el.classList.remove('active')
    })
}

window.addEventListener('click', (e) => {
    if (e.target.closest('.product-option-select--container') == null) {
        closeAllProductOptionContainers();
    } else {
        if (!(e.target.closest('.product-option-select--container').classList.contains('active'))) {
            closeAllProductOptionContainers();
            e.target.closest('.product-option-select--container').classList.add('active');
        } else {
            e.target.closest('.product-option-select--container').classList.toggle('active');
        }
    }
})

let getSelectedOption = (option) => {
    if (option.getAttribute('data-selected') != null) {
        return option.getAttribute('data-original-value');
    }
}

let findVariant = () => {
    // iterate over each product option and create a 'title' from the product ooptions currently selected to find the variant within the product json.
    // set the input name="id" value to the variant id
    let selectedProductOptions = [...productOptionValues].filter(getSelectedOption);
    let productVariantTitle;
    if (selectedProductOptions.length > 1) {
        productVariantTitleArr = [];
        selectedProductOptions.forEach((selectedOption) => {
            productVariantTitleArr.push(selectedOption.dataset.originalValue);
        })
        productVariantTitle = productVariantTitleArr.join(' / ');
    } else {
        productVariantTitle = selectedProductOptions[0].dataset.originalValue;
    }
    let finalVariant = JSON.parse(productJson.textContent).find((variant) => variant.title == productVariantTitle);
    if (finalVariant != undefined) {
        productIdInput.setAttribute('value', finalVariant.id)
    }
}

productOptionValues.forEach((valueOption) => {
    valueOption.addEventListener('click', () => {
        let parentEl = valueOption.parentElement;
        let closestValuesContainerItems = parentEl.children;
        [...closestValuesContainerItems].forEach((el) => {
            if (valueOption != el) {
                el.removeAttribute('data-selected');
            } else {
                el.setAttribute('data-selected', true);
                parentEl.parentElement.querySelector('.product-option-value--selected').innerHTML = el.getAttribute('data-original-value')
            }
        })
        findVariant();
    })
})

document.addEventListener('DOMContentLoaded', function () {
    var main = new Splide('#main-product--carousel', {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
        breakpoints: {
            600: {
                pagination:true,
            },
        },
    });

    var thumbnails = new Splide('#main-product--thumbnail-carousel', {
        gap: 10,
        rewind: true,
        pagination: false,
        arrows: false,
        isNavigation: true,
        perPage: 2,
        destroy:false,
        breakpoints: {
            600: {
                destroy:true,
            },
        },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
});